// src/pages/settings/system/JobQueuesTab.tsx
import React from "react";
import { Alert } from "antd";

import { queueServices } from "../../../api/queues/services";
import QueueServicePanel from "./QueueServicePanel";

// One panel per backend, stacked; each polls its own service every 15 s while the tab is mounted.
const JobQueuesTab: React.FC = () => {
	const services = queueServices();

	return (
		<div style={{ display: "flex", flexDirection: "column", gap: 16 }} data-testid="job-queues-tab">
			<Alert
				type="info"
				showIcon
				message="Job queues"
				description="Live Horizon status per backend service. Retry or delete failed jobs here, or escalate selected failures to the platform team. Horizon's own UI is not exposed — reach it with kubectl port-forward when deep debugging."
			/>
			{services.map((service) => (
				<QueueServicePanel key={service.key} service={service} />
			))}
		</div>
	);
};

export default JobQueuesTab;
